import {TopNavBarButtonComponent, TopNavBarButtonProps} from 'module/TopNavBar/component/TopNavBarButton/TopNavBarButtonComponent';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import React from 'react';
import {useSelector} from 'react-redux';
import {getHTMLRepresentation, getStringRepresentation} from 'model/Person';
import makeStyles from '@material-ui/core/styles/makeStyles';
import {selPersonSelected, selPersonTemplateId} from 'module/Person/selector/PersonSelector'

const useStyles = makeStyles(theme => ({
	labelText: {
		maxHeight: 24,
	},
}), {name: 'PersonPanelButton'});

export const PersonPanelButton = React.memo((props: TopNavBarButtonProps) => {
	const classes = useStyles()
	const {btnDef} = props
	const selected = useSelector(selPersonSelected)
	const templateId = useSelector(selPersonTemplateId)
	return (<TopNavBarButtonComponent{...props}>
			<SupervisorAccountIcon fontSize={'small'}/>&nbsp;
			{btnDef?.label && selected &&
				<span
					className={classes.labelText}
					title={getStringRepresentation(selected, templateId)}
					dangerouslySetInnerHTML={{__html: getHTMLRepresentation(selected, templateId)}}
				/>
				|| btnDef?.label &&
				<span className={classes.labelText}>Personen</span>
			}
		</TopNavBarButtonComponent>
	);
});